module.exports = require("./fr-YT.d.ts");